import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Organizations from "./pages/Organizations";
import Procurement from "./pages/Procurement";
import Sales from "./pages/Sales";
import UniformSales from "./pages/UniformSales";
import Reports from "./pages/Reports";
import { AuthContext } from "./context/AuthContext";
import { useMessage } from "./context/MessageContext";
import { registerShowMessage } from "./utils/messageHelper";

import MainLayout from "./components/MainLayout";
import BranchSetup from "./pages/BranchSetup";
import Masters from "./pages/Masters";
import Vendors from "./pages/Vendors";
import Preferences from "./pages/Preferences";
import AcademicYears from "./pages/AcademicYears";
import Catalog from "./pages/Catalog";
import UniformCatalog from "./pages/UniformCatalog";

import StockRequests from "./pages/StockRequests";
import StockReceipts from "./pages/StockReceipts";
import VendorPayments from "./pages/VendorPayments";

import InventoryDashboard from "./pages/InventoryDashboard";
import InventoryTransfer from "./pages/InventoryTransfer";
import InventoryUpload from "./pages/InventoryUpload";

import Students from "./pages/Students";
import SaleItemMapping from "./pages/SaleItemMapping";

import UserManagement from "./pages/UserManagement";

import ResetPassword from "./pages/ResetPassword";
import SalesDashboardPage from "./pages/reports/SalesDashboardPage";
import StudentDashboardPage from "./pages/reports/StudentDashboardPage";
import ItemDashboardPage from "./pages/reports/ItemDashboardPage";
import TeacherSetsReport from "./pages/TeacherSetsReport";

// import Sales from "./pages/Sales";

const ProtectedRoute = ({ children }) => {
  const { user, mustChangePassword } = useContext(AuthContext);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (mustChangePassword) {
    return <Navigate to="/reset-password" replace />;
  }

  return <MainLayout>{children}</MainLayout>;
};

const App = () => {
  const { user } = useContext(AuthContext);
  const { showMessage } = useMessage();

  useEffect(() => {
    registerShowMessage(showMessage);
  }, [showMessage]);

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={!user ? <Login /> : <Navigate to="/" />}
        />
        <Route
          path="/reset-password"
          element={user ? <ResetPassword /> : <Navigate to="/login" />}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orgs"
          element={
            <ProtectedRoute>
              <Organizations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/procurement"
          element={
            <ProtectedRoute>
              <Procurement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/branches"
          element={
            <ProtectedRoute>
              <BranchSetup />
            </ProtectedRoute>
          }
        />
        <Route
          path="/org-data"
          element={
            <ProtectedRoute>
              <Masters />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendors"
          element={
            <ProtectedRoute>
              <Vendors />
            </ProtectedRoute>
          }
        />
        <Route
          path="/preferences"
          element={
            <ProtectedRoute>
              <Preferences />
            </ProtectedRoute>
          }
        />
        <Route
          path="/academic-years"
          element={
            <ProtectedRoute>
              <AcademicYears />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalog"
          element={
            <ProtectedRoute>
              <Navigate to="/catalog/books" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalog/books"
          element={
            <ProtectedRoute>
              <Catalog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalog/uniforms"
          element={
            <ProtectedRoute>
              <UniformCatalog />
            </ProtectedRoute>
          }
        />

        <Route
          path="/procurement/requests"
          element={
            <ProtectedRoute>
              <StockRequests />
            </ProtectedRoute>
          }
        />

        <Route
          path="/procurement/receipts"
          element={
            <ProtectedRoute>
              <StockReceipts />
            </ProtectedRoute>
          }
        />

        <Route
          path="/procurement/payments"
          element={
            <ProtectedRoute>
              <VendorPayments />
            </ProtectedRoute>
          }
        />

        <Route
          path="/inventory/dashboard"
          element={
            <ProtectedRoute>
              <InventoryDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/inventory/transfer"
          element={
            <ProtectedRoute>
              <InventoryTransfer />
            </ProtectedRoute>
          }
        />

        <Route
          path="/inventory/upload"
          element={
            <ProtectedRoute>
              <InventoryUpload />
            </ProtectedRoute>
          }
        />

        <Route
          path="/inventory/teacher-sets"
          element={
            <ProtectedRoute>
              <TeacherSetsReport />
            </ProtectedRoute>
          }
        />

        <Route
          path="/students"
          element={
            <ProtectedRoute>
              <Students />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales"
          element={
            <ProtectedRoute>
              <Sales />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales/uniforms"
          element={
            <ProtectedRoute>
              <UniformSales />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales/item-mappings"
          element={
            <ProtectedRoute>
              <SaleItemMapping />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />

        {/* Reports */}
        <Route
          path="/sales/dashboard"
          element={
            <ProtectedRoute>
              <SalesDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales/student/dashboard"
          element={
            <ProtectedRoute>
              <StudentDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales/item/dashboard"
          element={
            <ProtectedRoute>
              <ItemDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
